/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getUserHomeKeyRpc = {
  serviceName: 'com.hubspot.nav.config.rpc.NavConfigHomeService',
  rpcName: 'getUserHomeKey',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABIFDJQFwsrU4CXdm6kAeYx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveHomeRpc = {
  serviceName: 'com.hubspot.nav.config.rpc.NavConfigHomeService',
  rpcName: 'resolveHome',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADbmd5HKG5t8ICXdm6kAeYx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHomeOptionsRpc = {
  serviceName: 'com.hubspot.nav.config.rpc.NavConfigHomeService',
  rpcName: 'getHomeOptions',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA3agNm-mAl4YCXdm6kAeYx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setHomeOptionRpc = {
  serviceName: 'com.hubspot.nav.config.rpc.NavConfigHomeService',
  rpcName: 'setHomeOption',
  auth: 'app',
  fingerprint: 'XADQPCyYdcGOUe2e_r4XmYCXdm6kAeYx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};